import { Alert, Box } from "@mantine/core";

import SvgIconRaw from "~/components/SvgIconRaw";
import { Message } from "~/utils/Types";

const ALERT_PRESETS = {
  error: { color: "red", icon: <SvgIconRaw name="AlertCircle" size={24} /> },
  warning: {
    color: "yellow",
    icon: <SvgIconRaw name="AlertTriangle" size={24} />,
  },
  info: { color: "blue", icon: <SvgIconRaw name="InfoOutlined" size={24} /> },
  success: {
    color: "green",
    icon: <SvgIconRaw name="CheckCircle" size={24} />,
  },
} as const;

interface props {
  message: Message;
}

const ServerMessage = ({ message }: props) => {
  const preset = ALERT_PRESETS[message.type] ?? ALERT_PRESETS.info;

  return (
    <Box m={8} w="100%">
      <Alert color={preset.color} icon={preset.icon}>
        {message.text}
      </Alert>
    </Box>
  );
};
export default ServerMessage;
